import './styles.css';
import Nav from './components/Nav';
import Hero from './components/Hero';
import Projects from './components/Projects';
import Maker from './components/Maker';
import Contact from './components/Contact';

export default function App() {
  return (
    <div className="lw-shell">
      <a className="lw-skip" href="#main">본문으로 건너뛰기</a>
      <Nav />
      <main id="main">
        <Hero />
        <Projects />
        <Maker />
        <Contact />
      </main>
    </div>
  );
}
